const e = "Incrémenter le nombre", n = "Décrémenter le nombre", r = {
  increment: e,
  decrement: n
};
export {
  n as decrement,
  r as default,
  e as increment
};
